// extracted by mini-css-extract-plugin
export default {"question__wrapper":"Hint_question__wrapper__k7N4S","question__title":"Hint_question__title__GCRYh"};